export enum ErrorType {
  UnknownError = 0,
  SessionExpired = 1,
  PermissionsChanged = 2,
  UserBlocked = 3,
  OrderDeleteError = 4,
  OrderConfirmationError = 5,
  ExcelError = 6,
  ImportSQLError = 7,
  IOError = 8,
  Unused = 9,
  Unused2 = 10,
  PermissionDenied = 11,
  RefundNotAvailable = 12,
  InvalidParameters = 13,
  ErrorMessage = 14,
  InvalidExcelDocument = 15,
  InvalidFileType = 16,
  ImportSQLTimeout = 17,
  SQLError = 18,
  ItemOutOfDate = 19,
  PartialSuccessWithMessage = 20, // spec says 19; backend enum confirms 20
}

export interface ReturnObject<T> {
  oData: T;
  bError?: boolean;
  eErrorType?: ErrorType;
  sMessage?: string;
  iAffected?: number;
  iQID?: number;
}
